// extracted by mini-css-extract-plugin
export default {"my-certificates-table":"MyCertificatesTable_my-certificates-table__IOfEK"};